import React from 'react';
// @mui
import RefreshIcon from '@mui/icons-material/Refresh';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';

interface ReloadButtonProps {
  tooltip?: string;
  isFetching: boolean;
  onRefetch: () => void;
}

const ReloadButton: React.FC<ReloadButtonProps> = ({ tooltip, isFetching, onRefetch }) => (
  <Tooltip title={tooltip ?? 'Reload'}>
    {isFetching ? (
      <CircularProgress size={20} sx={{ mt: 2, ml: 1 }} />
    ) : (
      <IconButton size="small" sx={{ mb: 1 }} onClick={() => onRefetch()}>
        <RefreshIcon />
      </IconButton>
    )}
  </Tooltip>
);

export default ReloadButton;
